import React, { useEffect, useState } from "react"
import Constants from "src/helper/Constants";
import Helper from "src/helper/Helper";
import System from "src/helper/system";
import { useDOMAttachToSystemStore } from "src/hooks/domAttachToSystem";
import { profileStore } from "src/hooks/profile";
import { __remove, __set } from "src/store/axios_indicator";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";

const ShippingMethodPopup = (props) => {
    const { avnetCarrierType: { FEDEX, UPS, DHL }, shippingCarrierType: { MANUAL, AVNET } } = Constants
    const defaultData = {
        carrierType: DHL,
        carrierOption: '',
    }
    const { data: { shipadd, carrier }, SetStatus } = props;
    const [__check] = useAxiosIndicatorCheck();
    const { translation: t } = System;
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const [{ all_carriers }, { fetch_all_carrier_data, get_profile_account_information }, { set_account_address_default }] = profileStore();
    const [errors, setErrors] = useState({})
    const [activeTab, setActiveTab] = useState(AVNET)
    const [avnetData, setAvnetData] = useState(defaultData)
    const [manualData, setManualData] = useState({
        carrierType: '',
        carrierOption: '',
        carrierAccount: ''
    })

    useEffect(() => {
        async function fetchHere() {
            const params = {
                orderId: 0,
                country: shipadd?.address?.countryName,
                countryCode: shipadd?.address?.countryCode,
                shipToId: shipadd?.id,
                speedboat: System.avUserInfoData.speedBoatAbbr,
            }
            __set('GET_CARRIER_DATA')
            await fetch_all_carrier_data({
                params: params,
                isOnlyAvnet: false
            });

            __remove('GET_CARRIER_DATA')

        }
        fetchHere()
    }, [])

    useEffect(() => {
        if (carrier && Object.keys(carrier)?.length > 0) {
            if (carrier?.carrierType === AVNET) {
                setAvnetData({
                    carrierType: carrier?.carrierKey,
                    carrierOption: carrier?.id
                })
            } else {
                setManualData({
                    carrierType: carrier?.carrierKey,
                    carrierOption: carrier?.id,
                    carrierAccount: carrier?.carrierAccount
                })
            }
            setActiveTab(carrier?.carrierType)
        } else {
            setAvnetData({
                carrierType: DHL,
                carrierOption: all_carriers?.dhl?.[0]?.id
            })
        }
    }, [carrier, all_carriers])

    const onChange = (type, key, value) => {
        if (errors && Object.keys(errors)?.length > 0) {
            delete errors[key]
        }
        type === AVNET ? setAvnetData({ ...avnetData, [key]: value }) : setManualData({ ...manualData, [key]: value })
    }

    // Account number validations
    const validateAccountNumber = (carrier, accountNumber) => {
        switch (carrier) {
            case 'UPS':
                // Length must be exactly 6 alphanumeric characters
                return Helper.validateRegex(accountNumber, /^[a-zA-Z0-9]{6}$/) ? '' : t('carrierAccountNumberAndShipmodeDoesNotMatch');
            case 'DHL':
                // Starts with 95 or 96 followed by up to 15 alphanumeric characters
                return Helper.validateRegex(accountNumber, /^(95|96)[a-zA-Z0-9]{0,13}$/) ? '' : t('carrierAccountNumberAndShipmodeDoesNotMatch');
            case 'FedEx':
                // Length must be exactly 9 digits and valid check digit
                return (accountNumber.length === 9 && Helper.validateRegex(accountNumber, /^\d{9}$/) && Helper.validateRegex(accountNumber, /^\d+$/)) ? '' : t('carrierAccountNumberAndShipmodeDoesNotMatch');
            default:
                return (accountNumber?.length <= 15 && accountNumber?.length !== 0) ? '' : t('carrierAccountNumberAndShipmodeDoesNotMatch');
        }
    }

    const renderCarriers = (carriers = []) => {
        return carriers.map((ele) => (
            <div className="form-check mb-1">
                <input
                    className="form-check-input mt-1"
                    type="radio"
                    name="avtcarrier"
                    id={`avtcarrier${ele.id}`}
                    value={avnetData.carrierOption}
                    checked={activeTab === AVNET && avnetData?.carrierOption !== ''}
                    onClick={() => { onChange(AVNET, 'carrierOption', ele.id) }}
                />
                <label className="form-check-label" htmlFor={`avtcarrier${ele.id}`}>
                    {ele.carrierOption}
                </label>
                {errors.carrierOption && <p className="error">{errors.carrierOption}</p>}
            </div>
        ));
    }

    const setDefaultAddress = async () => {
        let validationModal = {};
        if (activeTab === MANUAL) {
            if (!manualData?.carrierOption) {
                validationModal.carrierOption = t('pleaseSelectCarrierAccount');
            }
            if (!manualData?.carrierAccount?.length) {
                validationModal.carrierAccount = t('ValidCarrierAccountNumberIsRequired');
            }

            const type = all_carriers?.intl?.find(ele => ele.id === Number(manualData?.carrierOption))?.carrierKey

            let accountValidationMessage = validateAccountNumber(type, manualData?.carrierAccount);
            if (accountValidationMessage && type) {
                validationModal.shipMode = accountValidationMessage;
            }
        } else if (activeTab === AVNET) {
            if (!avnetData?.carrierOption) {
                validationModal.carrierOption = t('pleaseSelectCarrierAccount');
            }

        }
        setErrors(validationModal);

        if (Object.keys(validationModal)?.length > 0) {
            return;
        }

        const data = {
            "preferenceType": "Default_Carrier",
            "preferenceValue": activeTab === AVNET ? avnetData.carrierOption : (manualData?.carrierOption + '-' + manualData?.carrierAccount),
            "preferenceFilter": ''
        };

        __set('SET_SHIPPING_METHOD')
        const res = await set_account_address_default(data);
        if (res) {
            system_alert_indicator({
                name: 'profile',
                message: t('defaultShippingMethodHasBeenUpdated'),
                type: "success"
            })
            await get_profile_account_information();
            SetStatus(false)
        }
        __remove('SET_SHIPPING_METHOD')
    };

    return (
        <div className="avnet-modal modal-550">
            <div className="avnet-modal-inner">
                <button type="button" className="close py-3" data-dismiss="modal" disabled={__check(['SET_SHIPPING_METHOD']).status} onClick={(() => SetStatus(false))}>×</button>
                <div className="modal-header justify-content-center mt-0">
                    <h3 className="pcn-modal-heading pl-5">{t('shippingMethod')}</h3>
                </div>
                <div className="modal-body py-0">
                    <div className="clearfix" />
                    <div className='text-center mt-2 mb-4'>
                        {t('pleaseSelectCarrierOption')}
                    </div>
                    <div className="product-detail-tab-area shippingmethodtabs">
                        <ul className="bs5 nav nav-tabs dark-tabs nav-justified mob-tabs-row m-t-20">
                            <li className={`bs5 nav-item ${activeTab === AVNET && 'active'}`}>
                                <a className="bs5 nav-link text-none" data-toggle="tab" href={AVNET}
                                    onClick={(e) => { setActiveTab(e.currentTarget.attributes.href.value); }}><h2 className='m-0 font-13 font-arial'>{t('useAvnetsCarrierOptions')}</h2></a>
                            </li>

                            <li className={`bs5 nav-item ${activeTab === MANUAL && 'active'}`}>
                                <a className="bs5 nav-link text-none" data-toggle="tab" href={MANUAL}
                                    onClick={(e) => { setActiveTab(e.currentTarget.attributes.href.value); }}><h2 className='m-0 font-13 font-arial'>{t('useMyCarrierAccount')}</h2></a>
                            </li>
                        </ul>
                        <div id={activeTab} className="active py-4 mb-4" >
                            {__check(['GET_CARRIER_DATA']).render}
                            {!__check(['GET_CARRIER_DATA']).status && (
                                activeTab === AVNET && (
                                    <>
                                        <div className='d-flex'>

                                            {all_carriers?.dhl?.length > 0 && <button
                                                className={`bs5 btn btn-black me-2`}
                                                onClick={() => onChange(AVNET, 'carrierType', DHL)}
                                            >
                                                Dhl
                                            </button>}
                                            {all_carriers?.fedEx?.length > 0 && <button
                                                className={`bs5 btn btn-black me-2`}
                                                onClick={() => onChange(AVNET, 'carrierType', FEDEX)}
                                            >
                                               Fedex
                                            </button>}
                                            {all_carriers?.ups?.length > 0 && <button
                                                className={`bs5 btn btn-black`}
                                                onClick={() => onChange(AVNET, 'carrierType', FEDEX)}
                                            >
                                                Ups
                                            </button>}
                                        </div>

                                        <div className='mx-0 px-0 mt-3'>
                                            {(avnetData.carrierType.toLowerCase() === DHL || activeTab === AVNET) && renderCarriers(all_carriers?.dhl)}
                                            {avnetData.carrierType.toLowerCase() === FEDEX && renderCarriers(all_carriers?.fedEx)}
                                            {avnetData.carrierType.toLowerCase() === UPS && renderCarriers(all_carriers?.ups)}
                                        </div>
                                    </>
                                )
                            )}
                            {activeTab === MANUAL && (
                                <div className='form'>
                                    {__check(['GET_CARRIER_DATA']).render}
                                    {!__check(['GET_CARRIER_DATA']).status && (
                                        <>
                                            <div className="mb-3">
                                                <label htmlFor="accountNumber" className="form-label">{t('accountNumber')}*</label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control-sm  ${(errors.carrierAccount || errors.shipMode) && 'error'}`}
                                                    id="accountNumber"
                                                    placeholder={t('accountNumber')}
                                                    value={manualData?.carrierAccount}
                                                    onChange={({ target: { value } }) => onChange(MANUAL, 'carrierAccount', value)}
                                                />
                                                {errors.carrierAccount && <p className="error">{errors.carrierAccount}</p>}
                                            </div>
                                            <div className="mb-3"><label htmlFor="useMyCarrierAccount" className="form-label">{t('useMyCarrierAccount')}*</label>
                                            <div className='selectbox'>
                                                    <select
                                                        className={`form-control form-control-sm  ${(errors.carrierOption || errors.shipMode) && 'error'}`}
                                                        name="useMyCarrierAccount"
                                                        value={manualData?.carrierOption}
                                                        onChange={({ target: { value } }) => onChange(MANUAL, 'carrierOption', value)}
                                                    >
                                                        <option value="" >- {t('pleaseSelect')} -</option>
                                                        {all_carriers?.intl?.map((v, i) => (
                                                            <option key={v.id} value={v.id}>{v.carrierKey}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                {errors.carrierOption && <p className="error">{errors.carrierOption}</p>}
                                                {errors.shipMode && <p className="error">{errors.shipMode}</p>}
                                            </div>
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="modal-footer justify-content-center">
                    <div className="modal-footer-actions">
                        <button type="button" className="bs5 btn btn-secondary btn-sm w145" data-dismiss="modal" disabled={__check(['SET_SHIPPING_METHOD']).status} onClick={(() => SetStatus(false))}>
                            Cancel
                        </button>
                        <button className="bs5 btn btn-primary btn-sm w145"
                            onClick={() => setDefaultAddress()}
                        >
                            {__check(['SET_SHIPPING_METHOD']).status ?
                                <i className="fa fa-spinner fa-spin" /> :
                                t('submit')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ShippingMethodPopup